import './KeyResourceContent.css';
import Container from '@material-ui/core/Container';

function KeyResourceContent(){
    return(
        <>
            <div className="main-container" id='main'>
                <title>LKM Portal - Key Resources</title>
                <img src="images/portal-links/key-resources-new-banner.jpg" alt="Key- Resource banner" className='banner-img'/>
            </div>
            <Container className='awards-container' maxWidth="xl">
                <div className="awards-wrap">
                    <p> 
                        Key Resources encompasses significant LKM assets to deliver value proposition to our 
                        people. It is a complete repository of all key learning resources - Program links, eCatalogs, Circle, SharePoint, 
                        etc.
                    </p>
                </div>                
            </Container>
            <div className="accordion container" id="accordionExample">
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            Internal Links
                        </button>
                    </h2>
                    <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                            <div className="row align-items-center">
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                                <h2>Our People Agenda</h2>
                            </div>
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                                <div className="content-wraper">
                                <div className="img-box">
                                    <img src="images/portal-links/LKM-myXperience.png" alt="" />
                                </div>
                                <div className="content-box">
                                    <h3>LKM myXperience</h3>
                                    <a href="https://atci.lkm.accenture.com/" target="blank" className="click-here">Click Here</a>
                                </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                                <div className="content-wraper">
                                <img src="images/portal-links/line.png" className="line-img" alt="" />
                                <div className="img-box">
                                    <img src="images/portal-links/Learning-Conquerors2.0.png" alt="" />
                                </div>
                                <div className="content-box">
                                    <h3>Learning Conquerors 2.0</h3>
                                    <a href="https://ts.accenture.com/sites/idclkm/LKM-LearningCoE/Gamify_new/SitePages/New_home.aspx" target="blank" className="click-here">Click Here</a>
                                </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                            </div>
                            </div>

                            <div className="row align-items-center">
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                                <h2>Executive Enablement</h2>
                            </div>
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                                <div className="content-wraper">
                                <div className="img-box">
                                    <img src="images/portal-links/Value-Driven-ClientConversations.png" alt="" />
                                </div>
                                <div className="content-box">
                                    <h3>Value Driven Client Conversations</h3>
                                    <a href="https://lkmportal.atci.accenture.com/VDCC/" target="blank" className="click-here">Click Here</a>
                                </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                                <div className="content-wraper">
                                <img src="images/portal-links/line.png" className="line-img" alt="" />
                                <div className="img-box">
                                    <img src="images/portal-links/Living-Systems.png" alt="" />
                                </div>
                                <div className="content-box">
                                    <h3>Living Systems</h3>
                                    <a href="https://lkmportal.atci.accenture.com/LivingSystems/" target="blank" className="click-here">Click Here</a>
                                </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                                <div className="content-wraper">
                                <img src="images/portal-links/line.png" className="line-img" alt="" />
                                <div className="img-box">
                                    <img src="images/portal-links/Aspira(Coursera-Specializations).png" alt="" />
                                </div>
                                <div className="content-box">
                                    <h3>Aspira (Coursera Specializations)</h3>
                                    <a href="https://circles.accenture.com/17261e38-3592-4380-afe2-5a7d75305289?tab=home" target="blank" className="click-here">Click Here</a>
                                </div>
                                </div>
                            </div>
                            </div>

                            <div className="row align-items-center">
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                                <h2>Entry-Level</h2>
                            </div>
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                                <div className="content-wraper">
                                <div className="img-box">
                                    <img src="images/portal-links/TechVersant.png" alt="" />
                                </div>
                                <div className="content-box">
                                    <h3>Tech Expressway</h3>
                                    <a href="https://atci.techexpressway.accenture.com/home" target="blank" className="click-here">Click Here</a>
                                </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                            </div>
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                            </div>
                            </div>

                            <div className="row align-items-center">
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                                <h2>Learning Tracks</h2>
                            </div>
                            <div className="col-12 col-sm-12 col-md-9 col-lg-9 mx-auto">
                                <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
                                <div className="carousel-inner">
                                    <div className="carousel-item active">
                                    <div className="row">
                                        <div className="col-12 col-sm-12 col-md-4 col-lg-4 mx-auto">
                                        <div className="content-wraper">
                                        <div className="img-box">
                                            <img src="images/portal-links/cloud-elevate.png" alt="" />
                                        </div>
                                        <div className="content-box">
                                            <h3>Cloud Elevate</h3>
                                            <a href="https://circles.accenture.com/17261e38-3592-4380-afe2-5a7d75305289?tab=home" target="blank" className="click-here">Click Here</a>
                                        </div>
                                        </div>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-4 col-lg-4 mx-auto">
                                        <div className="content-wraper">
                                        <img src="images/portal-links/line.png" className="line-img" alt="" />
                                        <div className="img-box">
                                            <img src="images/portal-links/deep-knowedge.png" alt="" />
                                        </div>
                                        <div className="content-box">
                                            <h3>Deep Knowledge Portal</h3>
                                            <a href="https://deepknowledge.accenture.com/home/index.html" target="blank" className="click-here">Click Here</a>
                                        </div>
                                        </div>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-4 col-lg-4 mx-auto">
                                        <div className="content-wraper">
                                        <img src="images/portal-links/line.png" className="line-img" alt="" />
                                        <div className="img-box">
                                            <img src="images/portal-links/DLF.png" alt="" />
                                        </div>
                                        <div className="content-box">
                                            <h3>DLF</h3>
                                            <a href="https://lkmportal.atci.accenture.com/DLF/" target="blank" className="click-here">Click Here</a>
                                        </div>
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                    <div className="carousel-item">
                                    <div className="row">
                                        <div className="col-12 col-sm-12 col-md-4 col-lg-4 mx-auto">
                                        <div className="content-wraper">
                                        <div className="img-box">
                                            <img src="images/portal-links/Quality-Engineering.png" alt="" />
                                        </div>
                                        <div className="content-box">
                                            <h3>Quality <br/> Engineering</h3>
                                            <a href="https://circles.accenture.com/17261e38-3592-4380-afe2-5a7d75305289?tab=home" target="blank" className="click-here">Click Here</a>
                                        </div>
                                        </div>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-4 col-lg-4 mx-auto">
                                        <div className="content-wraper">
                                            <img src="images/portal-links/line.png" className="line-img" alt="" />
                                            <div className="img-box">
                                                <img src="images/portal-links/SAP-normal.png" alt="" />
                                            </div>
                                            <div className="content-box">
                                                <h3>SAP</h3>
                                                <a href="https://atci.lkm.accenture.com/sap" target="blank" className="click-here">Click Here</a>
                                            </div>
                                        </div>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-4 col-lg-4 mx-auto">
                                        <div className="content-wraper">
                                        <img src="images/portal-links/line.png" className="line-img" alt="" />
                                        <div className="img-box">
                                            <img src="images/portal-links/SAP-HEC.png" alt="" />
                                        </div>
                                        <div className="content-box">
                                            <h3>SAP HEC</h3>
                                            <a href="https://lkmportal.atci.accenture.com/SAPHEC/" target="blank" className="click-here">Click Here</a>
                                        </div>
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Previous</span>
                                </button>
                                <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Next</span>
                                </button>
                                </div>
                            </div>
                            </div>

                            <div className="row align-items-center">
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                                <h2>Inclusion and Diversity</h2>
                            </div>
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                                <div className="content-wraper">
                                <div className="img-box">
                                    <img src="images/portal-links/Sustainable-SoftwarePortal.png" alt="" />
                                </div>
                                <div className="content-box">
                                    <h3>Sustainable Software Portal</h3>
                                    <a href="https://atci.sustainability.accenture.com/" target="blank" className="click-here">Click Here</a>
                                </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-4 col-lg-4 mx-auto">
                                <div className="content-wraper">
                                <img src="images/portal-links/line.png" className="line-img" alt="" />
                                <div className="img-box">
                                    <img src="images/portal-links/CTRL_ALT_DEL_Inequality-AI_Hackathon.png" alt="" />
                                </div>
                                <div className="content-box">
                                    <h3>CTRL ALT DEL Inequality - AI Hackathon</h3>
                                    <a href="https://in.accenture.com/india/?site=1&blog=548&p=72539&preview=true&referrer=mailer" target="blank" className="click-here">Click Here</a>
                                </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-2 col-lg-2 mx-auto">
                            </div>
                            </div>

                            <div className="row align-items-center">
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                                <h2>Learning Operations</h2>
                            </div>
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                                <div className="content-wraper">
                                <div className="img-box">
                                    <img src="images/portal-links/VendorTrainingRequest.png" alt="" />
                                </div>
                                <div className="content-box">
                                    <h3>Vendor Training Request</h3>
                                    <a href="https://mytap.accenture.com/" target="blank" className="click-here">Click Here</a>
                                </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                            </div>
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                            </div>
                            </div>

                            <div className="row align-items-center">
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                                <h2>Digital Learning</h2>
                            </div>
                            <div className="col-12 col-sm-12 col-md-9 col-lg-9 mx-auto">
                                <div id="carouselExampleControls2" className="carousel slide" data-bs-ride="carousel">
                                <div className="carousel-inner">
                                    <div className="carousel-item active">
                                    <div className="row">
                                        <div className="col-12 col-sm-12 col-md-4 col-lg-4 mx-auto">
                                        <div className="content-wraper">
                                            <div className="img-box">
                                            <img src="images/portal-links/Aspira-sharepoint.png" alt="" />
                                            </div>
                                            <div className="content-box">
                                            <h3>Aspira Sharepoint</h3>
                                            <a href="https://go.accenture.com/ASPIRA" target="blank" className="click-here">Click Here</a>
                                            </div>
                                        </div>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-4 col-lg-4 mx-auto">
                                        <div className="content-wraper">
                                            <img src="images/portal-links/line.png" className="line-img" alt="" />
                                            <div className="img-box">
                                            <img src="images/portal-links/digital-manufacturing.png" alt="" />
                                            </div>
                                            <div className="content-box">
                                            <h3>Digital Manufacturing</h3>
                                            <a href="https://connectedlearning.accenture.com/learningboard/942187-digital-twin-the-new-normal" target="blank" className="click-here">Click Here</a>
                                            </div>
                                        </div>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-4 col-lg-4 mx-auto">
                                        <div className="content-wraper">
                                            <img src="images/portal-links/line.png" className="line-img" alt="" />
                                            <div className="img-box">
                                            <img src="images/portal-links/dl-nominations.png" alt="" />
                                            </div>
                                            <div className="content-box">
                                            <h3>DL nominations sharepoint</h3>
                                            <a href="https://go.accenture.com/DLNominations" target="blank" className="click-here">Click Here</a>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                    <div className="carousel-item">
                                    <div className="row">
                                        <div className="col-12 col-sm-12 col-md-4 col-lg-4 mx-auto">
                                        <div className="content-wraper">
                                            <img src="images/portal-links/line.png" className="line-img" alt="" />
                                            <div className="img-box">
                                            <img src="images/portal-links/D2L.png" alt="" />
                                            </div>
                                            <div className="content-box">
                                            <h3>D2L</h3>
                                            <a href="https://accenture.desire2learn.com/d2l/home" target="blank" className="click-here">Click Here</a>
                                            </div>
                                        </div>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-4 col-lg-4 mx-auto">
                                        <div className="content-wraper">
                                            <img src="images/portal-links/line.png" className="line-img" alt="" />
                                            <div className="img-box">
                                            <img src="images/portal-links/TechVersantsharepoint.png" alt="" />
                                            </div>
                                            <div className="content-box">
                                            <h3>Tech Expressway Sharepoint</h3>
                                            <a href="https://go.accenture.com/TVNomination" target="blank" className="click-here">Click Here</a>
                                            </div>
                                        </div>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-4 col-lg-4 mx-auto">
                                        <div className="content-wraper">
                                            <img src="images/portal-links/line.png" className="line-img" alt="" />
                                            <div className="img-box">
                                            <img src="images/portal-links/traveler-sharepoint.png" alt="" />
                                            </div>
                                            <div className="content-box">
                                            <h3>Travelers sharepoint</h3>
                                            <a href="https://go.accenture.com/Travelers" target="blank" className="click-here">Click Here</a>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                    <div className="carousel-item">
                                    <div className="row">
                                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 mx-auto">
                                        <div className="content-wraper">
                                            <div className="img-box">
                                            <img src="images/portal-links/project-management-foundation.png" alt="" />
                                            </div>
                                            <div className="content-box">
                                            <h3>Project Management Foundation</h3>
                                            <a href="https://connectedlearning.accenture.com/topics/project-management-foundation" target="blank" className="click-here">Click Here</a>
                                            </div>
                                        </div>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 mx-auto">
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls2" data-bs-slide="prev">
                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Previous</span>
                                </button>
                                <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls2" data-bs-slide="next">
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Next</span>
                                </button>
                                </div>
                            </div>
                            </div>

                            <div className="row align-items-center">
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                                <h2>LKM eCatalogs</h2>
                            </div>
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                                <div className="content-wraper">
                                <div className="img-box">
                                    <img src="images/portal-links/LearningProgramsE-Catalog.png" alt="" />
                                </div>
                                <div className="content-box">
                                    <h3>Learning Programs eCatalogs</h3>
                                    <a href="https://ts.accenture.com/sites/idclkm/LKM-LearningCoE/LKM-Leads/Documents/Forms/AllItems.aspx?RootFolder=%2Fsites%2Fidclkm%2FLKM%2DLearningCoE%2FLKM%2DLeads%2FDocuments%2FLKM%20eCatalogs&FolderCTID=0x012000F45B57A115088140ADCC5DDA461C44AB&View=%7BE545BAA4%2D3BCF%2D4E8F%2DACF3%2DF53E5024512F%7D" target="blank" className="click-here">Click Here</a>
                                </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                            </div>
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                            </div>
                            </div>
                            <div className="row align-items-center">
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                                <h2>LKM Learning Offerings</h2>
                            </div>
                            <div className="col-12 col-sm-12 col-md-9 col-lg-9 mx-auto">
                                <div id="carouselExampleControls3" className="carousel slide" data-bs-ride="carousel">
                                <div className="carousel-inner">
                                    <div className="carousel-item active">
                                    <div className="row">
                                        <div className="col-12 col-sm-12 col-md-4 col-lg-4 mx-auto">
                                        <div className="content-wraper">
                                            <div className="img-box">
                                            <img src="images/portal-links/QIP.png" alt="" />
                                            </div>
                                            <div className="content-box">
                                            <h3>Quantum Impact Program</h3>
                                            <a href="https://atci.lkm.accenture.com/QuantumImpact/home" target="blank" className="click-here">Click Here</a>
                                            </div>
                                        </div>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-4 col-lg-4 mx-auto">
                                        <div className="content-wraper">
                                            <img src="images/portal-links/line.png" className="line-img" alt="" />
                                            <div className="img-box">
                                            <img src="images/portal-links/SAP-normal.png" alt="" />
                                            </div>
                                            <div className="content-box">
                                            <h3>SAP</h3>
                                            <a href="https://atci.lkm.accenture.com/sap" target="blank" className="click-here">Click Here</a>
                                            </div>
                                        </div>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-4 col-lg-4 mx-auto">
                                        <div className="content-wraper">
                                            <img src="images/portal-links/line.png" className="line-img" alt="" />
                                            <div className="img-box">
                                                <img src="images/portal-links/SAP-HEC.png" alt="" />
                                            </div>
                                            <div className="content-box">
                                                <h3>SAP HEC</h3>
                                                <a href="https://lkmportal.atci.accenture.com/SAPHEC/" target="blank" className="click-here">Click Here</a>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                    <div className="carousel-item">
                                    <div className="row">
                                        <div className="col-12 col-sm-12 col-md-4 col-lg-4 mx-auto">
                                        <div className="content-wraper">
                                            <div className="img-box">
                                            <img src="images/portal-links/TechVersant.png" alt="" />
                                            </div>
                                            <div className="content-box">
                                            <h3>Tech Expressway</h3>
                                            <a href="https://atci.techexpressway.accenture.com/home" target="blank" className="click-here">Click Here</a>
                                            </div>
                                        </div>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-4 col-lg-4 mx-auto">
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-4 col-lg-4 mx-auto">
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls3" data-bs-slide="prev">
                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Previous</span>
                                </button>
                                <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls3" data-bs-slide="next">
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Next</span>
                                </button>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="accordion-item" style={{border: '1px solid rgba(0,0,0,.125)'}}>
                    <h2 className="accordion-header" id="headingTwo">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                            External Links
                        </button>
                    </h2>
                    <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                            
                            <div className="row align-items-center">
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                                <h2>Learning Tracks</h2>
                            </div>
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                                <div className="content-wraper">
                                <div className="img-box">
                                    <img src="images/portal-links/A-Cloud-Guru.png" alt="" />
                                </div>
                                <div className="content-box">
                                    <h3>A Cloud Guru</h3>
                                    <a href="https://acloudguru.com/" target="blank" className="click-here">Click Here</a>
                                </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                            </div>
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                            </div>
                            </div>

                            <div className="row align-items-center">
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                                <h2>Digital Learning</h2>
                            </div>
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                                <div className="content-wraper">
                                <div className="img-box">
                                    <img src="images/portal-links/Coursera.png" alt="" />
                                </div>
                                <div className="content-box">
                                    <h3>Coursera</h3>
                                    <a href="https://www.coursera.org/" target="blank" className="click-here">Click Here</a>
                                </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                                <div className="content-wraper">
                                <img src="images/portal-links/line.png" className="line-img" alt="" />
                                <div className="img-box">
                                    <img src="images/portal-links/Pluralsight.png" alt="" />
                                </div>
                                <div className="content-box">
                                    <h3>Pluralsight</h3>
                                    <a href="https://www.pluralsight.com/" target="blank" className="click-here">Click Here</a>
                                </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                            </div>
                            </div>

                            <div className="row align-items-center">
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                                <h2>Digital Library</h2>
                            </div>
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                                <div className="content-wraper">
                                <div className="img-box">
                                    <img src="images/portal-links/Overdrive.png" alt="" />
                                </div>
                                <div className="content-box">
                                    <h3>OverDrive</h3>
                                    <a href="https://accenture.lib.overdrive.com" target="blank" className="click-here">Click Here</a>
                                </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                                <div className="content-wraper">
                                <img src="images/portal-links/line.png" className="line-img" alt="" />
                                <div className="img-box">
                                    <img src="images/portal-links/Magzter.png" alt="" />
                                </div>
                                <div className="content-box">
                                    <h3>Magzter</h3>
                                    <a href="https://www.magzter.com/accenture/" target="blank" className="click-here">Click Here</a>
                                </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mx-auto">
                            </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>            
        </>    
    )
}

export default KeyResourceContent